module.exports = __webpack_public_path__ + "img/default_header_logo.0c1100f0.svg";